import React, { memo, useEffect, useState } from 'react'
import styles from './distributionTaskTimeAnalysis.less'
import { Flex, Select, Statistic } from 'antd'
import { request } from '../../../../../../tool/http'
// import HumanLineChart from '@/pages/containers/dashboard/contentView/view/showEchart/humanLineChart/humanLineChart'


function DistributionTaskTimeAnalysis(props: any) {
  // console.log('每天的在线人数---展示', props)
  // const [showType, setShowType] = useState(props.contentMsg?.dataConfig?.contentParams?.typeShowSel || [1])
  let showType = props.contentMsg?.dataConfig?.contentParams?.typeShowSel || [1]
  const [errorMsg, setErrorMsg] = useState('')
  const [time, setTime] = useState(1)
  const [data, setData] = useState<any>([])
  const [option, setOption] = useState<any>({})
  const [takeSelectType, setTakeSelectType] = useState(0)
  //时间类型
  const [timeType, setTimeType] = useState(1)

  //请求业务数据
  const getBusinessData = () => {
    setErrorMsg('')
    let group = 'day'
    group = time === 1 ? (timeType === 1 ? 'hour' : 'localHour') : (timeType === 1 ? 'day' : 'localDay')
    request(`${props.contentMsg?.proConfig?.apiPrefix}/taskStatistics/getDistributionTimes`, {
      data: {
        businessType: props.contentMsg?.proConfig?.usageParams?.usageCode,  //1.公司 2.空间 3.执行单元
        businessId: [props.contentMsg?.proConfig?.usageParams?.businessId],
        time,
        type: takeSelectType ? takeSelectType : '',
        group
      }
    }).then((res) => {
      if (res.code === 200) {
        setData(res.data)
      } else {
        setErrorMsg(res.message)
      }
    }).catch((err) => {
      setErrorMsg(err.toString())
    })
  }
  useEffect(() => {
    getBusinessData()
  }, [showType, time, props.dataUpdate, takeSelectType, timeType])

  //获取图表数据
  const getOption = () => {
    let dataFilter = [] as any[]
    let dataKey: any = {}
    //判断showType选中的值
    if (showType.includes(1) && showType.includes(2)) {
      dataKey = {
        distribute: '分发数量',
        startNum: '开始数量',
        // fail: '失败',
        // noExec: '未执行',
        // timeout: '超时',
        // undistributed: '未分发'
      }
    } else if (showType.includes(1)) {
      dataKey = {
        distribute: '分发数量',
      }
    } else if (showType.includes(2)) {
      dataKey = {
        startNum: '开始数量',
      }
    }
    // console.log('分发日志--dataKey', dataKey)
    //对应数据字段


    Object.keys(dataKey).forEach((key: any) => {
      if (dataKey[key]) {
        let count = [] as any[]
        if (dataKey[key] === '分发数量') {
          count = data.map((item: any) => item.distribute)
        } else {
          count = data.map((item: any) => item.timeout + item.fail + item.running + item.success)
        }
        dataFilter.push({
          _id: dataKey[key],
          count: count
        })
      }
    })
    let xAxis = [
      {
        axisLabel: {
          rotate: 30
        },
        //截取字段
        data: data.map((item: any) => {
          return time === 1 ? (item?.hour?.slice(8) || item?.localHour?.slice(8)) + '时' : (item?.day || item?.localDay)
        })
      }
    ]
    let series = dataFilter.map((item: any) => {
      return {
        name: item._id,
        type: props?.contentMsg?.dataConfig?.contentType === 'system_distributionTaskTimeAnalysisTwo' ? 'bar' : 'line',
        [props?.contentMsg?.dataConfig?.contentType === 'system_distributionTaskTimeAnalysis' ? 'polarIndex' : 'xAxisIndex']: 0,
        data: item.count,
        areaStyle: {
          opacity: 0.5
        }
      }
    })
    let option = {
      polar: props?.contentMsg?.dataConfig?.contentType === 'system_distributionTaskTimeAnalysis',
      xAxis,
      series
    }
    // console.log('分发日志--option', option)
    setOption(option)
  }
  useEffect(() => {
    // console.log('data====', data)
    if (data.length > 0) {
      getOption()
    }
  }, [data])
  return (
    <div className={styles.outer + " swiper-no-swiping"}>
      <div
        className={styles.chartBox}
      >
        {
          errorMsg
            ? <div className={styles.errorMsg}>
              {errorMsg}
            </div>
            : <Flex vertical style={{ width: '100%', height: '100%' }}>
              <Flex>
                <Flex justify='end' flex={1} className={" swiper-no-swiping"}>
                  <Select
                    style={{ width: "120px" }}
                    value={time}
                    onChange={(v) => {
                      setTime(v)
                    }}
                    options={[
                      { label: "今日", value: 1 },
                      { label: "30日", value: 30 },
                      { label: "15日", value: 15 },
                      { label: "7日", value: 7 },
                    ]}
                  >
                  </Select>
                  <Select style={{ width: "120px", marginLeft: '10px' }}
                    value={takeSelectType}
                    onChange={(v) => {
                      setTakeSelectType(v)
                    }}
                    options={[
                      { label: "全部任务", value: 0 },
                      { label: "单次任务", value: 2 },
                      { label: "周期任务", value: 3 },
                    ]} >

                  </Select>
                  <Select style={{ width: "120px", marginLeft: '10px' }}
                    value={timeType}
                    onChange={(v) => {
                      setTimeType(v)
                    }}
                    options={[
                      { label: "北京时间", value: 1 },
                      { label: "当地时间", value: 2 },
                    ]} >
                  </Select>
                </Flex>
              </Flex>

              {/* <HumanLineChart option={option}></HumanLineChart> */}
            </Flex>
        }
      </div>
    </div>

  )
}
export default memo(DistributionTaskTimeAnalysis)